module.exports = __webpack_public_path__ + "img/aykj.1f977374.png";